/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Faq_Q6Inputs */

const en_minifier_faq_q6 = /** @type {(inputs: Minifier_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is minified JSON still valid JSON?`)
};

const ko_minifier_faq_q6 = /** @type {(inputs: Minifier_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축된 JSON도 유효한 JSON인가요?`)
};

const ja_minifier_faq_q6 = /** @type {(inputs: Minifier_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮された JSON も有効な JSON ですか`)
};

/**
* | output |
* | --- |
* | "Is minified JSON still valid JSON?" |
*
* @param {Minifier_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_faq_q6 = /** @type {((inputs?: Minifier_Faq_Q6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Faq_Q6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_faq_q6(inputs)
	if (locale === "ko") return ko_minifier_faq_q6(inputs)
	return ja_minifier_faq_q6(inputs)
});